import React, { useCallback, useEffect, useState } from "react";
import { Alert } from "@intech/web-ui";
import { ListaPlanos, LoadingComponent, MasterPage } from "@components";
import { DadosPessoaisEntidade, PlanoVinculadoEntidade } from "@entidades";
import { DadosPessoaisService, FuncionalidadeService, PlanoVinculadoService } from "@services";
import { Header } from "./styles";
import { DMN_FUNCIONALIDADE, DMN_SIT_PLANO } from "@domains";
import { HomeAtivo } from "./HomeAtivo";

export const Home: React.FC = ({ ...rest }) => {
  const [Planos, setPlanos] = useState<PlanoVinculadoEntidade[]>([]);
  const [PlanoSelecionado, setPlanoSelecionado] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [SqPlanoVinculado, setSqPlanoVinculado] = useState<number>(0);
  const [DadosPessoais, setDadosPessoais] = useState<DadosPessoaisEntidade>(new DadosPessoaisEntidade());

  const [Bloqueio, setBloqueio] = useState<string>("");
  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const planos = await PlanoVinculadoService.Buscar();

        if (planos.length > 0) {
          const plano = planos[0];

          setPlanoSelecionado(plano);
          setSqPlanoVinculado(plano.SQ_PLANO_PREVIDENCIAL);
        }

        setPlanos(planos);

        const DadosPessoais = await DadosPessoaisService.Buscar();
        setDadosPessoais(DadosPessoais);

      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (PlanoSelecionado.SQ_PLANO_PREVIDENCIAL) {
          const funcionalidade = (PlanoSelecionado.SQ_SIT_PLANO === DMN_SIT_PLANO.ATIVO || PlanoSelecionado.SQ_SIT_PLANO === 3) ? DMN_FUNCIONALIDADE.HOME_ATIVOS : DMN_FUNCIONALIDADE.HOME_ASSISTIDOS;
          const bloqueio = await FuncionalidadeService.BuscarBloqueiosPorNumFuncionalidade(funcionalidade, PlanoSelecionado.SQ_PLANO_PREVIDENCIAL, PlanoSelecionado.SQ_PLANO_PREVIDENCIAL, PlanoSelecionado.SQ_PLANO_PREVIDENCIAL);
          setBloqueio(bloqueio);
        }
      }
      catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
    })();
  }, [PlanoSelecionado]);

  const handleSelecionarPlano = useCallback((planoSelecionado: PlanoVinculadoEntidade) => {
    try {
      const plano = Planos.filter(x => x.SQ_PLANO_PREVIDENCIAL === planoSelecionado.SQ_PLANO_PREVIDENCIAL)[0];

      if (plano) {
        setPlanoSelecionado(plano);
        setSqPlanoVinculado(plano.SQ_PLANO_PREVIDENCIAL);
      }
      else {
        setErro("Houve uma falha ao selecionar o plano desejado.");
      }

    } catch (e) {
      const err: any = e;
      setErro(err.response ? err.response.data : err);
    }
  }, [Planos]);

  return (
    <MasterPage {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && Bloqueio && <Alert type={"danger"}>{Bloqueio}</Alert>}

      {!Loading && !Erro && !Bloqueio && Planos.length === 0 && <Alert type={"info"}>{"Nenhuma informação disponível no momento."}</Alert>}

      {!Loading && !Erro && !Bloqueio && Planos.length > 0 && <>
        {Planos.length > 1 && <>
          <Header>
            <h3>
              {`Olá ${DadosPessoais.NO_PESSOA}! `}
              {`${DadosPessoais.IR_SEXO === "M" ? "Bem-vindo" : "Bem-vinda"} ao`}
              {"Portal REGIUS!"}
            </h3>

            <h5>
              {"Atualmente você tem o(s) seguinte(s) planos com a gente:"}
            </h5>

            <div className="mb-3">{"(clique nos botões para mais informações)"}</div>

            <ListaPlanos planos={Planos} sqPlanoAtivo={SqPlanoVinculado} onChange={handleSelecionarPlano} />
          </Header>
        </>}

        {(PlanoSelecionado.SQ_SIT_PLANO === DMN_SIT_PLANO.ATIVO || PlanoSelecionado.SQ_SIT_PLANO === 3) && <HomeAtivo plano={PlanoSelecionado} />}

        {/* {PlanoSelecionado.SQ_SIT_PLANO === DMN_SIT_PLANO.ASSISTIDO && <HomeAssistido plano={PlanoSelecionado}/>} */}
      </>}
    </MasterPage>
  );
};
